<script>
  import Button from '@components/buttons/button.svelte'
  import Text from '@components/general/text.svelte'
  import { FileText } from 'lucide-svelte'
  import { cn } from '@lib/utils'

  let { selected = false, onSelect, class: className, ...buttonProps } = $props()

  let buttonClasses = $derived(cn(
    'flex flex-col justify-center items-center gap-3 w-full rounded-lg border-2 border-dashed px-5 py-6 text-center transition-all',
    className,
    'hover:border-gray-300 hover:shadow-sm',
    selected
      ? 'border-gray-400 bg-gray-50 ring-1 ring-gray-300/50'
      : 'border-gray-200 bg-white'
  ))

  let iconClasses = $derived(cn(
    'flex h-10 w-10 items-center justify-center rounded-full',
    selected ? 'bg-gray-200' : 'bg-gray-50'
  ))
</script>

<!-- Invoice request payment option (visually softer with dashed border) -->
<Button variant="naked" onclick={onSelect} class={buttonClasses} {...buttonProps}>
  
  <!-- Icon -->
  <div class={iconClasses}>
    <FileText size={20} class="text-gray-400" />
  </div>

  <!-- Title and description -->
  <div class="flex flex-col gap-0.5">
    <Text variant="section_title" text="Request invoice" />
    <Text variant="label" as="span" class="text-gray-500">We'll send you an invoice to pay</Text>
  </div>
</Button>
